import {
	Context,
	createContext
} from "react";
import { outOfContextCall } from "client/Misc/reactUtils";
import { DragCallbackArgs } from "client/Hooks";

export type ReorderableListItemContextData = {
	onUp: (() => void) | undefined;
	onDown: (() => void) | undefined;
	isReorderEnabled: boolean;
	dragStart: (args: DragCallbackArgs) => void;
	dragMove: (args: DragCallbackArgs) => void;
	dragStop: (args: DragCallbackArgs) => void;
	isDragging: boolean;
};

export const ReorderableListItemContext: Context<ReorderableListItemContextData> = createContext<ReorderableListItemContextData>({
	onUp: () => outOfContextCall("ReorderableListItemContext", "onUp"),
	onDown: () => outOfContextCall("ReorderableListItemContext", "onDown"),
	isReorderEnabled: false,
	dragStart: () => outOfContextCall("ReorderableListItemContext", "dragStart"),
	dragMove: () => outOfContextCall("ReorderableListItemContext", "dragMove"),
	dragStop: () => outOfContextCall("ReorderableListItemContext", "dragStop"),
	isDragging: false,
});
